import InputMask from "react-input-mask";
import React from "react";
import {
  fieldContainer,
  fieldControlBase,
  fieldControlError,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

const CPFInput = ({
  error,
  label,
  name,
  value,
  onChange,
  onBlur,
  type = "text",
  required,
  ...props
}) => {
  return (
    <div className={fieldContainer}>
      {label && (
        <label htmlFor={name} className={fieldLabel}>
          {label}
        </label>
      )}

      <InputMask
        type={type}
        id={name}
        name={name}
        className={`${fieldControlBase} ${error ? fieldControlError : ""}`}
        placeholder=""
        mask="999.999.999-99"
        maskChar=""
        alwaysShowMask={false}
        value={value ?? ""}
        onChange={onChange}
        onBlur={onBlur}
        {...props}
      />

      {error && <small className={fieldErrorText}>{error}</small>}
    </div>
  );
};

export default CPFInput;
